import Vue from 'vue';

if (window.hwerrVue) {
  Vue.config.errorHandler = window.hwerrVue;
}

import App from '../../App.vue';
import router from '../rooters/webOfficialSupport';
import store from '../stores/webOfficialSupport';
import setCommonPlugins from '../../resource/configs/setGlobalCommonPlugins';
import globalConfig from '../../resource/utiles/globalConfig';

import { Icon } from 'vant';
import 'vant/lib/icon/style/less';
import '@plugins/replaceAllPolyfills';
Vue.use(Icon);

globalConfig.setPageTitleAndIco('support page');
setCommonPlugins(Vue);
Vue.config.productionTip = true;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#webOfficialSupport');
